import copy from './images/copy.svg'

export default function CopyIcon(props) {
  return (
    <img src={copy} alt="copy" onClick={props.onClick} />
  )
}
